import {
  VALIDATE_RESTORE_PASSWORD_BEGIN,
  VALIDATE_RESTORE_PASSWORD_SUCCESS,
  VALIDATE_RESTORE_PASSWORD_FAILURE,
  VALIDATE_RESTORE_PASSWORD_DISMISS_ERROR
} from './constants'
import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../../common/config'

export function updateValidateRestorePassword(uuid) {
  return dispatch => {
    dispatch({
      type: VALIDATE_RESTORE_PASSWORD_BEGIN
    })
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        REACT_APP_API_ABM_FW + `/users/${uuid}/validateResetPassword`,
      )
      doRequest.then(
        res => {
          if (res.data) {
            dispatch({
              type: VALIDATE_RESTORE_PASSWORD_SUCCESS,
              data: res.data
            })
            resolve(res)
          } else {
            dispatch({
              type: VALIDATE_RESTORE_PASSWORD_FAILURE,
              data: res.data
            })
            resolve()
          }
        },
        err => {
          dispatch({
            type: VALIDATE_RESTORE_PASSWORD_FAILURE,
            data: { error: err }
          })
          resolve()
        }
      )
    })
    return promise
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case VALIDATE_RESTORE_PASSWORD_BEGIN:
      return {
        ...state,
        validateRestorePasswordPending: true,
        validateRestorePasswordError: null
      }

    case VALIDATE_RESTORE_PASSWORD_SUCCESS:
      return {
        ...state,
        validateRestorePasswordPending: false,
        validateRestorePasswordError: null,
        validatedUserPhoneNumber: action.data.phoneNumber,
        validatedUserId: action.data.userId
      }

    case VALIDATE_RESTORE_PASSWORD_FAILURE:
      return {
        ...state,
        validateRestorePasswordPending: false,
        validateRestorePasswordError: action.data.error
      }

    case VALIDATE_RESTORE_PASSWORD_DISMISS_ERROR:
      return {
        ...state,
        validateRestorePasswordError: null
      }

    default:
      return state
  }
}
